import { useEffect, useState } from 'react';

export function usePoolingPhaseTick({
	isCrowdLockMode,
	lobbyResponse,
}: {
	isCrowdLockMode: boolean;
	lobbyResponse: any;
}) {
	const gameStartDate = lobbyResponse?.game_start_date
		? new Date(lobbyResponse.game_start_date).getTime()
		: null;

	const [poolingNow, setPoolingNow] = useState(() => Date.now());

	useEffect(() => {
		if (!isCrowdLockMode) return;
		if (!gameStartDate) return;

		if (Date.now() >= gameStartDate) return;

		const id = setInterval(() => {
			setPoolingNow(Date.now());
		}, 250);

		return () => clearInterval(id);
	}, [isCrowdLockMode, gameStartDate]);

	const isPoolingPhaseActive = isCrowdLockMode && gameStartDate && poolingNow < gameStartDate;

	return { gameStartDate, isPoolingPhaseActive, setPoolingNow };
}
